import React from "react";
import { Box } from "rebass/styled-components";
import WidgetContainer, { WidgetHeader } from "./WidgetContainer";
import { colors } from "../../../theme";
import LinePlot from "./LinePlot";
import BarPlot from "./BarPlot";

const metricColors = {
  impressions: colors.blue,
  engagements: colors.orange,
  audience: colors.purple,
  followers: colors.greenActive
};

function AnalyticsSubplot({
  title = "Metric",
  period = 7,
  description = "",
  metricId,
  series,
  type = "bar",
  color = "#0063FB",
  indexBy = "date",
  data
}) {
  const PlotComponent = props => {
    if (type === "line")
      return <LinePlot data={data} indexBy={indexBy} {...props} />;
    else return <BarPlot data={data} indexBy={indexBy} {...props} />;
  };

  const bucket = period > 90 ? "week" : "day";
  return (
    <WidgetContainer>
      {(() => {
        const parts = [];
        if (period) parts.push(`last ${period} days`);
        if (bucket === "week") parts.push("weekly totals (Mon–Sun)");
        if (description && description.length > 0) parts.push(description);
        return (
          <WidgetHeader
            title={title}
            description={parts.join(" · ")}
          />
        );
      })()}
      <Box p={16}>
        <PlotComponent
          metricId={metricId}
          series={series}
          color={metricColors[metricId] ?? color}
          bucket={bucket}
        />
      </Box>
    </WidgetContainer>
  );
}

export default AnalyticsSubplot;
